import styled from "styled-components"

export const StyledIFrame = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  z-index: 1;

  & iframe{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
  }
`
